import * as z from "zod/v4";
import { salesChannelSchema } from "./sales-channel";

export const setRedoSalesChannels = {
  name: "setRedoSalesChannels" as const,
  input: z.object({ redoSalesChannels: z.array(salesChannelSchema) }),
  output: z.null(),
};
